{
  "app": {
    "adblock": {
      "title": "请禁用您的广告拦截插件",
      "text": "某些浏览器插件会阻止此网页运行，如广告拦截插件，请禁用",
      "done": "完成-重新加载应用程序"
    }
  },
  "campaign": {
    "targetType": {
      "LOCAL": "本地",
      "CHINESE_TOURISTS": "中国游客",
      "all": "全部"
    },
    "stats": {
      "reportType": {
        "week": "周",
        "day": "日",
        "market": "市场",
        "media": "媒体",
        "format": "广告形式",
        "creative": "素材创意"
      }
    }
  },
  "page": {
    "summary": {
      "sendForReviewHint1": "一旦您点击“发送至预览”按钮，您提交的需求将无法更改",
      "sendForReviewHint2": "如果您需要进行更改，请联系Cosmose客户经理。",
      "downloadSpotplan": "下载媒体排期",
      "budgetSplitQuestion": "您想如何分配您的预算？",
      "totalCampaignBudget": "活动总预算"
    },
    "login": {
      "title": "登录",
      "forgotPassword": "忘记密码？",
      "credentialsError": "登录信息错误，请重试",
      "accountIssue": "您的账户信息有误，请尝试联系客服中心",
      "enterACode": "输入代码",
      "next": "继续",
      "back": "返回",
      "2faTitle": "二次验证",
      "2faSubtitle": "从谷歌验证程序获取验证码",
      "invalidToken": "代码错误，请重新尝试"
    },
    "resetPassword": {
      "title": "输入您的电子邮箱",
      "description": "我们会向您发送密码重置链接。",
      "enterNewPassword": "输入新密码",
      "passwordChanged": "您的密码已成功更改！",
      "thankYou": "谢谢。",
      "goToLoginScreen": "跳转到登录页面",
      "error401": "登录信息错误，请重试",
      "patternConstraints": "密码必须至少包含一个大写字母，一个小写字母，一个数字",
      "lengthConstraints": "密码字符长度不得超出12个"
    },
    "objective": {
      "localAudience": {
        "targetGroup": "本地受众",
        "title": "你的目标是什么？"
      },
      "chineseTourists": {
        "targetGroup": "中国游客",
        "title": "您的目的地是哪里？"
      },
      "title": "你的目标是什么？",
      "chooseStrategy": "选择策略",
      "iNeedSomeGuidance": "我需要一些指导",
      "startFromScratch": "从头开始",
      "iFeelLikeAPro": "我已经很熟悉该系统",
      "createYourOwnGoal": "创建自己的目标",
      "goalName": "目标名称",
      "egNewProductLaunch": "例如新品发布",
      "target": "目标受众",
      "clients": {
        "selectClient": "选择账户",
        "addNewClient": "Add new client"
      }
    },
    "campaign": {
      "createCampaign": "创建活动",
      "addNewPlatform": "添加新平台",
      "globalCampaignLink": "全球活动链接",
      "addFormat": "添加广告形式",
      "platformSetup": "平台设置",
      "noResult": "抱歉，未找到相关结果。",
      "saveSuccess": "活动保存成功！",
      "updateError": "抱歉，您的更改未保存！",
      "noSavedChanges": "您所做的更改尚未保存。",
      "operationSuccess": "操作已成功完成！",
      "publishSuccess": "您的活动已成功设置！",
      "submitForReviewSuccess": "您的活动“{{campaignName}}”已发送以供审阅",
      "submitForReviewContact": "Cosmose客户经理将在4个小时内通过电子邮件与您联系",
      "deleteSuccess": "活动已成功删除！",
      "estimatesTip": "这是对您目标人群量级的预估，这个数字将随着下面参数的选择而变化",
      "rejectedCampaignBy": "您的活动已被拒绝",
      "timezone": "日期以您当地的时区为准。",
      "budgetTip": "提出的价值是预算估算。此处展示的是一个预算预估，受到受众体量、触达频次和触达比例的相互影响。总预算包含媒体净预算、数据费、服务费和税费。",
      "estimatedAudienceSize": "预估受众量级",
      "estimatedAudienceSizeCalculating": "正在计算预估受众量级",
      "details": "计划详情",
      "searchCampaignByName": "按活动名称搜索"
    },
    "campaigns": {
      "title": "欢迎回来！",
      "localCampaign": "本地投放",
      "chineseTouristsCampaign": "中国游客投放"
    },
    "report": {
      "metricsTooltips": {
        "backToAllMetrics": "返回所有指标",
        "conversions": "线下转换数据延迟，会在投放结束后的一周后显示"
      },
      "campaignReport": "Campaign report.xlsx",
      "downloadReport": "下载报告",
      "postBuyReport": "下载结案报告",
      "summary": "总结",
      "keyMetrics": "关键指标",
      "overview": "概览",
      "adSetMetrics": "广告集指标",
      "engagement": "帖子互动",
      "peopleReached": "触达人群",
      "individualCustomerVisits": "单独消费者访问",
      "delayDataTip": "报告中的数据存在一天延迟",
      "impressions": "曝光",
      "clicks": "点击",
      "clickThroughRate": "点击率",
      "uniqueViews": "独立访客",
      "averageFrequency": "平均频次",
      "costPerMille": "每千次广告展示成本",
      "costPerClick": "点击成本",
      "details": "计划详情",
      "organicTraffic": "自然访客流量",
      "noDataMessage": "数据报告未生成",
      "conversions": "转化",
      "metricsType": {
        "all": "所有指标",
        "impressions": "曝光",
        "clicks": "点击",
        "clickThroughRate": "点击率",
        "uniqueViews": "独立访客",
        "averageFrequency": "平均频次",
        "costPerMille": "每千次广告展示成本",
        "costPerClick": "点击成本",
        "conversions": "转化",
        "postComments": "發表評論",
        "postEngagements": "帖子互动",
        "postReactions": "帖子心情",
        "postShares": "帖子分享",
        "onlineConversions": "线上购买",
        "videoP100watchedActions": "100% Video view",
        "videoP25watchedActions": "25% Video view",
        "videoP50watchedActions": "50% Video view",
        "videoP75watchedActions": "75% Video view",
        "videoP99watchedActions": "99% Video view"
      },
      "postComments": "發表評論",
      "postEngagements": "帖子互动",
      "postReactions": "帖子心情",
      "postShares": "帖子分享",
      "filterBy": "筛选",
      "filter": "筛选",
      "brandPreferences": {
        "showBrandPreferences": "显示品牌偏好",
        "tooltip": "数据收集自投放时间段内"
      },
      "uploadStats": "上传数据",
      "uploadStatsSuccess": "数据上传成功",
      "All segments": "人群标签",
      "onlineConversions": "线上购买",
      "videoP100watchedActions": "100% Video view",
      "videoP25watchedActions": "25% Video view",
      "videoP50watchedActions": "50% Video view",
      "videoP75watchedActions": "75% Video view",
      "videoP99watchedActions": "99% Video view"
    },
    "planner": {
      "downloadLocationsList": "下载店铺地址详单",
      "downloadBudget": "下载预算报价单",
      "downloadRequirements": "下载物料制作要求",
      "platformGroup": {
        "selectAll": "选择所有",
        "deselectAll": "删去所有",
        "details": "简要介绍"
      },
      "label": {
        "BEFORE_TRIP": "出行前",
        "DURING_TRIP": "出行中"
      },
      "nav": {
        "audience": "目标受众",
        "groups": "人口统计",
        "timeline": "投放时间",
        "budget": "预算方案",
        "media": "投放媒体"
      },
      "groups": {
        "title": "群组",
        "question": "您想触达哪类人群？",
        "addInterests": "添加兴趣标签+",
        "addAnother": "添加+",
        "income": "收入水平",
        "interests": "兴趣爱好",
        "searchBehaviour": "搜索行为",
        "educationLevel": "教育水平",
        "targetMarkets": "您想在哪个城市进行投放？",
        "specificCities": "特定城市",
        "nationWide": "全国"
      },
      "budget": {
        "title": "预算",
        "question": "您的活动预算是多少？",
        "withThisBudgetYouCanReach": "有了这个预算，你可以达到",
        "ofTargetAudience": "目标受众的比例。",
        "resetWithThisBudget": "重新设定预算",
        "resetToDefaultSetup": "恢复默认设置",
        "budgetTooLow": "预算不足",
        "howWouldYouLikeToSplitBudget": "您想如何分配预算？",
        "totalCampaignBudget": "总活动预算",
        "disabledDuringtripTip": "您将仅投放“出行中”的受众",
        "minBudgetHint": "最低预算门槛是 {{value}}",
        "changedBudgetHint": "请点击应用进入下一步",
        "maxBudgetHint": "最高预算是 {{value}}",
        "apply": "应用"
      },
      "timeline": {
        "title": "投放时间",
        "question": "您的投放时间是？",
        "spotplan": {
          "media": "媒体",
          "adFormat": "广告形式",
          "audienceExplanation": "受众人群说明",
          "regionAndSchedule": "区域和时间安排",
          "potentialCustmersReached": "预估能触达的潜在目标人群",
          "buyingModel": "购买模式",
          "averageFrequency": "平均触达频次",
          "numberOfImpressions": "曝光量",
          "maxUnitPrice": "最高单位价格",
          "cosmoseAiDataFee": "Cosmose AI数据费",
          "cosmoseAiDataFeeLocations": "1-500个地点",
          "cosmoseServiceFee": "COSMOSE服务费",
          "cosmoseServiceFeeInvestment": "媒体投入的3%",
          "totalBudgetIncludingVat": "预算总额(含6%增值税)",
          "campaign": "活动",
          "campaignId": "活动ID",
          "cities": "城市",
          "locations": "位置",
          "campaignDate": "活动时间",
          "channel": "渠道",
          "format": "广告形式",
          "unit": "单位",
          "totalUnits": "总量",
          "pricePerUnit": "单价",
          "totalCost": "总成本",
          "estImpressions": "预估曝光",
          "estClicks": "预估点击",
          "estCtr": "预估点击率",
          "estimatedCostPerClick": "预估点击成本"
        }
      },
      "audience": {
        "moreCompetitors": "更多竞品",
        "addAnother": "添加+",
        "title": "受众",
        "question": "您的目标人群可能出现在哪些地方？",
        "audienceLikelyToGoShopping": "受众有可能会去购物",
        "audienceLikelyToGoShoppingTip": "选择本周人们购物的可能性。该预测是根据每周的购物数据更新的，于每周一更新。不太可能转化的人群意味着覆盖的人群量较大，转化几率较小；可能性较大的人群意味着一小部分人，但是对转化有积极倾向",
        "brandSectionTitle": "哪些品牌应该纳入预测范围？",
        "brandSectionTitleTip": "至少选择一个品牌。",
        "selectedBrands": "可能会购买的受众：",
        "selectCompetitorsBrands": "选择竞品品牌",
        "showBrandsInGroups": "分组展示品牌",
        "brandsInGroups": "集团品牌",
        "yours": "您的消费者",
        "competitors": "竞争品牌店铺",
        "ownStoresTooltip": "只是看看-访问过您的店铺但没有购买就离开了\n\n橱窗购物者-仅在店铺外停留，没有进店访问\n\n您的客户-在您的店铺中购买商品的人",
        "selectLocationsHint": "选择抓取目标受众的店铺地址",
        "downloadLocationsList": "下载店铺地址明细",
        "selectCitiesHint": "选择抓取受众的城市",
        "selectDurationHint": "选择抓取受众的时间周期",
        "selectDurationDesc": "在此期间至少访问过一次",
        "selectDurationTooltip": "例如过去1个月/3个月",
        "cosmoseAiRecommendationTurnOn": "开启Cosmose AI 推荐",
        "cosmoseAiRecommendationTurnOff": "关闭Cosmose AI 推荐",
        "cosmoseAiRecommendationTooltipLine1": "预选项是由CosmoseAI推荐的店铺覆盖",
        "cosmoseAiRecommendationTooltipLine2": "如果您想清空重置，请关闭推荐",
        "chooseBusinessCategories": "Business Categories",
        "businessCategories": "Business Categories",
        "other": "Other"
      },
      "media": {
        "platformBudgetTooLow": "要投放该媒体，预算至少需要{{value}}",
        "selectAllPlatforms": "选择所有媒体",
        "deselectAllPlatforms": "取消所有媒体",
        "selectAllFormats": "选择所有广告形式",
        "deselectAllFormats": "取消所有广告形式",
        "title": "媒体",
        "question": "您想使用哪些媒体？",
        "splitBudget": "预算分配",
        "budgetSplitIncorrectly": "您的预算分配不正确",
        "budgetTooLowOrUndefined": "预算太低/或尚未定义",
        "splitBudgetPerPlatform": "按媒体分配预算",
        "addNewPlatform": "添加媒体平台",
        "createNewAdSet": "创建新的广告集",
        "platform": "媒体平台",
        "format": "广告形式",
        "description": "平台介绍",
        "landingPageUrl": "落地页URL",
        "choosePlatforms": "选择媒体平台",
        "chooseFormats": "选择广告形式",
        "adSetSubcategories": {
          "OPEN_SCREEN": "开屏广告",
          "FEED_ADS": "信息流广告",
          "REGULAR_BANNER": "常规横幅",
          "FOCUS_PIC": "焦点图"
        },
        "errors": {
          "landingPageUrl": "落地页链接错误",
          "files": "未添加任何文件",
          "description": "描述是必填项",
          "platform": "媒体平台是必填项",
          "format": "格式是必填项"
        },
        "categories": {
          "ONLINE_VIDEO": "在线视频",
          "SOCIAL_MEDIA": "社交媒体",
          "NEWS": "新闻资讯",
          "FITNESS": "健康健身",
          "ENTERTAINMENT": "娱乐影音",
          "PHOTO_TAKING_AND_BEAUTY": "拍摄美化",
          "MUSIC": "在线音乐",
          "LIFE_CONVENIENCE": "便捷生活",
          "COOKING_GUIDE": "营养食谱",
          "OTA": "订票服务",
          "UTILITY": "实用工具",
          "RECOMMENDED": "推荐应用",
          "SPORTS": "体育运动",
          "GOURMET": "美酒美食",
          "TRAVEL": "在线旅游",
          "TOOLS": "个人工具",
          "MATERNITY": "女性亲子",
          "Facebook": "Facebook",
          "Instagram": "Instagram"
        },
        "downloads": "下载量",
        "dailyUsers": "日均用户",
        "openScreen": "开屏",
        "focusPic": "焦点图",
        "feedAds": "常规横幅",
        "regularBanner": "信息流"
      },
      "files": {
        "summary": {
          "header": "其他活动文件"
        }
      },
      "assets": {
        "name": "名字",
        "size": "尺寸",
        "description": "描述",
        "modified": "修改",
        "addFiles": "添加文件",
        "edit": "编辑",
        "delete": "删除",
        "cancel": "取消",
        "save": "保存",
        "or": "或者",
        "uploadYourAssets": "上传您的素材",
        "uploadNewAssets": "更新素材",
        "noAssets": "此活动尚无素材保存"
      },
      "selectAll": "选择所有",
      "deselectAll": "取消所有",
      "TIER_1": "一线城市",
      "TIER_2": "二线城市",
      "backToDashboard": "返回主界面",
      "platformNameFIlter": {
        "searchAppByName": "按名称搜索"
      },
      "platformListSelection": {
        "all": "全部",
        "selected": "已选",
        "notSelected": "未选",
        "show": "显示"
      },
      "guidedTour": {
        "action": {
          "next": "下一步",
          "previous": "上一步",
          "exitDemo": "退出产品展示"
        },
        "china": {
          "campaignListAddNewCampaign": {
            "description": "设想您想开始策划一波新的广告投放",
            "nextStepDescription": "下一步：点击“添加新活动”"
          },
          "campaignObjectiveSelectLocalAudience": {
            "description": "您打算触达“当地受众”"
          },
          "campaignObjectiveSelectNewStoreOpening": {
            "description": "假设您投放活动的背景是支持“新店开业”。Cosmose AI将根据您的选择提供一些活动预设",
            "nextStepDescription": "下一步：点击“新店开业”"
          },
          "plannerStartSelectAudience": {
            "description": "这里是Cosmose导向栏，五个简单的步骤，您就可以轻松完成整个活动设置。让我们从设置受众开始。",
            "nextStepDescription": "下一步：点击”您的目标受众在哪里购物？”"
          },
          "audienceShowEstimates": {
            "description": "受众规模会根据您接下来的设置进行动态变化"
          },
          "audienceAskToHoverSegmentInfo": {
            "description": "受众群的进一步细分",
            "nextStepDescription": "下一步：（鼠标）悬停在”i“图标"
          },
          "audienceReadSegmentDescriptions": {
            "description": "阅读受众分类定义"
          },
          "audienceSelectCompetitors": {
            "description": "现在您可以定义您品牌的竞品名单",
            "nextStepDescription": "下一步：选择“Yves Saint Laurent“"
          },
          "audienceShowEstimatesChange": {
            "description": "受众规模增加"
          },
          "audienceSelectLocationCategories": {
            "description": "选择和您目标受众最相关的位置类型",
            "nextStepDescription": "下一步：选择 ”美术馆“"
          },
          "audienceExplainAddingLocationCategories": {
            "description": "添加的位置类型越多，您的受众规模就越大"
          },
          "audienceAskToSelectCity": {
            "description": "选择你想抓取受众数据的城市",
            "nextStepDescription": "下一步:选择 ”武汉“"
          },
          "audienceShowTimespan": {
            "description": "在这里设定抓取受众的时间节点"
          },
          "audienceAskToClickContinue": {
            "description": "让我们进入下一步",
            "nextStepDescription": "下一步：点击“继续”"
          },
          "demographicsSelectGender": {
            "description": "设置目标受众的人口属性特征",
            "nextStepDescription": "下一步：选择”女性“"
          },
          "demographicsAskToClickContinue": {
            "description": "让我们进入下一步",
            "nextStepDescription": "下一步：点击“继续”"
          },
          "budgetSelectCampaignDuration": {
            "description": "您可以在此选定投放周期"
          },
          "budgetCalculationExplanation": {
            "description": "推荐预算是根据活动上线周期和预估的受众量级提供的预估"
          },
          "budgetAskToClickContinue": {
            "description": "让我们进入下一步",
            "nextStepDescription": "下一步：点击“继续”"
          },
          "mediaSearchPlatform": {
            "description": "选择媒体渠道",
            "nextStepDescription": "下一步：搜索并选择“Zaker”"
          },
          "mediaSelectFormat": {
            "description": "您可以最适合的广告形式",
            "nextStepDescription": "下一步：点击“开屏”"
          },
          "mediaAskToClickContinue": {
            "description": "让我们进入下一步",
            "nextStepDescription": "下一步：点击“继续”"
          },
          "spotplanAnalyze": {
            "description": "生成活动预算排期"
          },
          "spotplanAskToClickSummary": {
            "description": "看起来不错",
            "nextStepDescription": "下一步：点击“总览信息”"
          },
          "summaryAskToClickSendForReview": {
            "description": "检查设定信息，确认无误后即刻提交审核",
            "nextStepDescription": "下一步：点击“提交审核”"
          },
          "sentForReviewAskToClickBackToDashboard": {
            "description": "这是一个产品示意。在实际操作中，点击提交审核后，Cosmose客户经理将在4个工作小时内通过电子邮件与您联系。",
            "nextStepDescription": "下一步：点击“返回主页面”"
          },
          "campaignListExposeCampaign": {
            "description": "您可以从主界面中进入要设置的广告活动"
          }
        },
        "japan": {
          "audienceSelectCompetitors": {
            "description": "现在您可以定义您品牌的竞品名单",
            "nextStepDescription": "下一步：选择“Rolex“"
          },
          "audienceAskToSelectCity": {
            "description": "选择你想抓取受众数据的城市",
            "nextStepDescription": "下一步:选择 ”Tokyo“"
          },
          "mediaSearchPlatform": {
            "description": "选择媒体渠道",
            "nextStepDescription": "下一步：搜索并选择“Video“"
          },
          "mediaSelectFormat": {
            "description": "您可以最适合的广告形式",
            "nextStepDescription": "下一步：点击“Video\""
          },
          "budgetAskToClickSummary": {
            "description": "让我们进入下一步",
            "nextStepDescription": "下一步：点击“总览信息”"
          },
          "audienceAnalyzeLocationCategories": {
            "description": "Analyze recommended business categories"
          },
          "audienceClickEditLocationCategories": {
            "nextStepDescription": "Click \"Edit\"",
            "description": "Select \"Edit\" to preview the entire list"
          },
          "audienceSelectLocationCategories": {
            "description": "Choose from a wide range of relevant location categories assigned to your brand",
            "nextStepDescription": "NEXT: Select \"Art gallery\""
          },
          "audienceCloseLocationCategoriesDialog": {
            "description": "Save your selection",
            "nextStepDescription": "Click \"Save\""
          },
          "audienceExpandCategory": {
            "description": "Expand category",
            "nextStepDescription": "NEXT: Click arrow"
          },
          "mediaExpandPlatform": {
            "description": "Expand platform by clicking on its name"
          }
        },
        "startDemoModal": {
          "welcome": "欢迎回来",
          "introduction": "我们准备了一个简单的演示，供您快速理解本产品的核心功能",
          "timespan": "大概用时5分钟",
          "startDemo": "开始演示"
        }
      },
      "platformNameFilter": {
        "searchAppByName": "按媒体名称搜索"
      }
    },
    "error": {
      "403": {
        "title": "禁止访问"
      },
      "404": {
        "title": "未找到页面"
      },
      "500": {
        "title": "服务器错误"
      }
    },
    "execution": {
      "comments": "评论",
      "uploadNewDocument": "上传新文档",
      "modal": {
        "areYouSure": "你确定你想",
        "thisItem": "该选项",
        "mandatoryField": "此字段为必填字段",
        "addComment": "添加建议",
        "approve": "批准",
        "reject": "拒绝",
        "sendForReview": "送审",
        "file": "文件",
        "wouldYouLikeToSendThisFileForReview": "是否要将此文件提交审阅？"
      },
      "sendForReviewModal": {
        "legalVerification": "感谢您提交资质文件，媒体平台将进行审核，并在3个工作日内回复您。",
        "creativeVerification": "感谢您提交创意素材，媒体平台将进行审核，并在3个工作日内回复您。",
        "trackingCodes": "感谢您提交监测代码，媒体平台将进行审核，并在2个工作日内回复您。"
      },
      "assetPackageLabels": {
        "BUSINESS_LICENSE": {
          "title": "营业执照",
          "subtitle": "必填字段"
        },
        "ICP_CERTIFICATION": {
          "title": "ICP证明",
          "subtitle": "如果落地页的URL以.cn结尾"
        },
        "PORTRAIT_RIGHT_DISCLAIMER": {
          "title": "肖像权免责声明",
          "subtitle": "如创意设计中包含名人/模特"
        },
        "CREATIVES": {
          "title": "创意素材",
          "subtitle": ""
        },
        "AD_PREVIEW": {
          "title": "广告预览",
          "subtitle": ""
        },
        "TRACKING_CODES": {
          "title": "监测代码设置",
          "subtitle": "",
          "SIZMEK_TRACKING_CODE": "Sizmek",
          "MIAOZHEM_SYSTEMS_TRACKING_CODE": "秒针系统",
          "DOUBLECLICK_TRACKING_CODE": "Doubleclick",
          "AD_MASTER_TRACKING_CODE": "AD Master"
        },
        "SIZMEK_TRACKING_CODE": {
          "title": "Sizmek",
          "subtitle": ""
        },
        "MIAOZHEM_SYSTEMS_TRACKING_CODE": {
          "title": "秒针系统",
          "subtitle": ""
        },
        "DOUBLECLICK_TRACKING_CODE": {
          "title": "Doubleclick",
          "subtitle": ""
        },
        "AD_MASTER_TRACKING_CODE": {
          "title": "Ad master",
          "subtitle": ""
        }
      },
      "legal-censorship": {
        "title": "资质审核",
        "headerTitle": "资质审核",
        "uploadDocuments": "上传资质文件以提交审核",
        "onceYouClick": "一旦您单击“提交审核”按钮，您提交的内容将无法更改。",
        "businessLicence": "营业执照",
        "icpCertification": "ICP认证",
        "portraitRightDisclaimer": "肖像权免责声明",
        "mandatoryField": "必填字段",
        "endsWith": "如果落地页的URL以.cn结尾",
        "ifCreative": "如创意设计中包含名人/模特",
        "IN_REVIEW": "资质文件已经发出，正在等待审核",
        "notUploadedYet": "资质文件尚未上传"
      },
      "creative-censorship": {
        "title": "素材审核",
        "headerTitle": "素材审核",
        "uploadCreatives": "上传素材以供审核",
        "tooltip": "这流程至少需要3个工作日，请在此之前上传您的素材",
        "notUploadedYet": "创意素材尚未上传"
      },
      "tracking-codes": {
        "title": "监测代码",
        "headerTitle": "监测代码设置",
        "pageUrl": "落地页URL",
        "chooseTrackingCodes": "选择要上传的监测代码",
        "uploadTrackingCodes": "上传监测代码",
        "notUploadedYet": "监测代码尚未上传"
      },
      "ad-preview": {
        "title": "广告预览",
        "headerTitle": "广告预览确认",
        "uploadAdPreview": "上传广告预览",
        "dpsHasNotYet": "DSP尚未上传广告预览",
        "letYouKnow": "广告预览可供查看后，我们会通过邮件通知您"
      },
      "asset-package-status": {
        "IN_REVIEW": "审核中",
        "APPROVED": "批准",
        "REJECTED": "拒绝"
      },
      "status": {
        "IN_REVIEW": "文件已经送审，正在等待审核结果",
        "APPROVED": "所有文件都已审核通过",
        "REJECTED": "所有文件都未审核通过"
      },
      "mobile": {
        "executionPhase": "执行阶段",
        "useDesktopVersion": "请使用网页版操作该环节"
      }
    }
  },
  "dynamicControls": {
    "image_title": {
      "placeholder": "文本",
      "tip": ""
    },
    "link_description": {
      "placeholder": "信息流链接描述",
      "tip": ""
    },
    "link_url": {
      "placeholder": "网站网址",
      "tip": ""
    },
    "visible_link_url": {
      "placeholder": "显示链接",
      "tip": ""
    },
    "fb_page_id": {
      "placeholder": "选择Facebook页面",
      "tip": ""
    },
    "instagram_account_id": {
      "placeholder": "选择Facebook页面",
      "tip": ""
    }
  },
  "platform": {
    "Facebook": "Facebook",
    "Instagram": "Instagram",
    "Wechat": "微信",
    "Moweather": "墨迹天气",
    "Weibo": "微博",
    "MangoTV": "芒果TV"
  },
  "label": {
    "comments": "评论",
    "audienceEstimation": "预估受众量级",
    "avgFrequency": "平均触达频次",
    "clearAll": "清空所有",
    "selectAll": "选择所有",
    "allBrandsSelected": "所有已选择的品牌",
    "brandsSelected": "选定的品牌",
    "budget": "预算",
    "deletePostSuccess": "发文已成功删除",
    "congratulations": "恭喜您!",
    "status": "状态",
    "expectedStatus": "预期",
    "showInfo": "显示信息",
    "hideInfo": "隐藏信息",
    "hide": "隐藏",
    "online": "线上",
    "offline": "线下",
    "campaigns": "活动",
    "username": "用户名",
    "emailAddress": "电子邮件地址",
    "password": "密码",
    "newPassword": "新密码",
    "repeatPassword": "确认密码",
    "currentPassword": "当前密码",
    "name": "名字",
    "enterLinkHere": "在此处输入链接",
    "price": "价格",
    "findPostId": "查找广告活动ID",
    "priceTip": "选择活动的价格",
    "type": "活动类型",
    "typeTip": "至少选择一种活动类",
    "frequencyCapping": "频率封顶",
    "frequencyCappingTip": "频次控制",
    "perClick": "选择触达频次",
    "timesPer": "次",
    "perUser": "每用户",
    "addImage": "添加图像",
    "description": "描述",
    "addNew": "添加",
    "campaignName": "计划名称",
    "actions": "行为",
    "format": "安排",
    "gender": "性别",
    "age": "年龄",
    "timeSpan": "时间跨度",
    "theMostPopular": "最受欢迎的",
    "other": "其他",
    "customBudget": "自定义预算",
    "budgetSpent": "已消耗预算",
    "budgetOf": "的",
    "daysLeft": "左边的",
    "currency": "货币单位",
    "campaignDuration": "活动投放周期",
    "selectDuration": "选择活动投放周期",
    "durationData": "投放周期日期",
    "dateRange": "日期范围",
    "customGroups": "自定义组",
    "competitors": "竞争品牌店铺",
    "brandOwnStores": "品牌自有店铺",
    "storeVisitors": "请定义上述地址类型的访问周期",
    "fillCorectData": "请确保所有值定义正确",
    "allFieldsAreMandatory": "所有都是必填字段",
    "filter": "筛选",
    "perViewer": "per viewer",
    "lessLikely": "不太可能",
    "veryLikely": "极有可能",
    "predictedVisitors": "预估到访人数",
    "utcTime": "UTC时间",
    "localTime": "当地时间",
    "createManually": "手动创建",
    "predictedAudience": "预估目标受众",
    "relevantLocationCategories": "相关地址类型",
    "recommendedImageSpecs": "推荐图像规格",
    "selectBrands": "选择品牌",
    "start": "开始",
    "cities": "城市",
    "reach": "触达率",
    "totalCampaignBudget": "活动总预算",
    "myBudget": "我的预算",
    "campaignEnded": "活动结束",
    "editMedia": "更改媒体选择",
    "preview": "广告预览",
    "visitsPeriod": "访问周期",
    "technicalSpec": "技术规格要求",
    "mediaSpotPlan": "媒体排期",
    "success": "成功",
    "storeTypes": {
      "ALL": "全部",
      "JUST_LOOKING": "店内随便看看",
      "WINDOW_SHOPPERS": "店外橱窗驻足",
      "OWN": "自有店铺",
      "YOUR_CUSTOMERS": "店内购买顾客",
      "COMPETITORS": "竞品顾客",
      "CUSTOM": "自定义"
    },
    "visitPeriodTypes": {
      "WEEK": "星期",
      "MONTH": "月",
      "QUARTER": "季度",
      "HALFYEAR": "半年",
      "YEAR": "年"
    },
    "currencies": {
      "HKD": "港元",
      "USD": "美金",
      "CNY": "人民币",
      "EUR": "欧元",
      "JPY": "日元"
    },
    "currenciesSymbol": {
      "HKD": "港元",
      "USD": "美金",
      "CNY": "人民币",
      "EUR": "欧元",
      "JPY": "日元"
    },
    "billingPeriodType": {
      "DAILY": "每日",
      "WEEKLY": "每周",
      "MONTHLY": "每月",
      "LIFETIME": "整个活动周期"
    },
    "adSetType": {
      "CPM": "千人成本",
      "CPC": "点击成本"
    },
    "frequency": {
      "week": "星期",
      "month": "月",
      "quarter": "季度"
    },
    "durations": {
      "days": "天",
      "weeks": "星期"
    },
    "genderType": {
      "ALL": "所有",
      "MALE": "男",
      "FEMALE": "女"
    },
    "statuses": {
      "ALL": "全部",
      "DRAFT": "草稿",
      "PUBLISHED": "已上线",
      "PENDING": "等待中",
      "FAILED": "失败",
      "PAUSED": "暂停",
      "IN_REVIEW": "审核中",
      "PLANNING": "计划中",
      "PLANNING_REVIEW": "活动审核中",
      "FINISHED": "已完成",
      "EXECUTION": "准备执行中"
    },
    "displayStatuses": {
      "resuming": "正在恢复",
      "pausing": "暂停"
    }
  },
  "popup": {
    "confirmation": "确认",
    "cancelTitle": "保存更改",
    "cancelText": "你确定要取消吗？",
    "cancelKeepDraftSuccess": "您的活动已保存为草稿",
    "pauseCampaignTitle": "暂停活动",
    "pauseCampaignText": "你确定要暂停活动吗？",
    "popupCampaignName": {
      "addNew": "添加活动名称",
      "edit": "编辑名称",
      "campaignName": "活动名称",
      "charactersLimit": "最多36个字节"
    }
  },
  "button": {
    "login": "登录",
    "logout": "注销",
    "create": "创建",
    "changeAudience": "更换受众",
    "resetPassword": "重置密码",
    "cancel": "取消",
    "continue": "继续",
    "save": "保存",
    "ok": "确定",
    "sendForReview": "提交审核",
    "nextStep": "下一步",
    "previousStep": "上一步",
    "confirm": "确认",
    "summary": "总结",
    "addNewPlatform": "添加新平台",
    "addNewCampaign": "添加新活动",
    "pauseCampaign": "暂停活动",
    "pauseCampaignConfirm": "确认暂停",
    "resume": "继续",
    "delete": "删除",
    "deletePost": "删除发布记录",
    "publish": "发布",
    "edit": "编辑",
    "show": "显示",
    "back": "返回",
    "showSummary": "显示摘要",
    "showReport": "显示报告",
    "showAll": "显示所有",
    "showLess": "显示部分",
    "report": "报告",
    "dashboard": "转到主界面",
    "backToDashboard": "返回主界面",
    "deleteCampaign": "删除活动",
    "keepDraft": "保存草稿",
    "remove": "清除",
    "addYourFile": "添加您的文件",
    "addTrackingCodes": "添加监测代码",
    "approve": "批准",
    "reject": "拒绝",
    "campaignSummary": "活动摘要",
    "downloadRequirements": "下载物料制作要求",
    "downloadSpotplan": "下载排期",
    "previous": "上一步",
    "goToExecution": "转到执行步骤",
    "downloadCampaignProposal": "下载活动提案"
  },
  "tip": {
    "recommendedImageSize": "推荐图片尺寸：{{width}}x{{Height}}像素",
    "minImageSize": "最小图片尺寸：{{minWidth}}x{{minHeight}}像素",
    "maxImageSize": "最大图片尺寸：{{maxWidth}}x{{maxHeight}}像素",
    "minAspectRatio": "最小纵横比：{{imageRatio}}",
    "recommendedAspectRatio": "推荐纵横比：{{imageRatio}}",
    "maxAspectRatio": "最大纵横比：{{imageRatio}}",
    "recommendedImageInfo": "为确保广告投放效果，请尽量不要在图片中使用字体，以免字体重叠",
    "recommendedExtensions": "请上传以下格式的文件:"
  },
  "error": {
    "imageUploader": {
      "dimensionsAndRatio": "图片长宽比错误",
      "dimensions": "图片尺寸无效",
      "ratio": "图片长宽无效",
      "ratioNotSameAsRecommended": "图片长宽有效，但不符合推荐格式。",
      "format": "文件格式无效"
    },
    "tooSmallEstimation": "预估受众量级太小，请添加更多群组",
    "email": "请输入有效的电子邮箱",
    "required": "此字段为必填字段",
    "minlength": "值太短",
    "maxlength": "值太长",
    "min": "值太小",
    "max": "值太大",
    "pattern": "格式无效",
    "repeatNotSame": "密码不匹配",
    "mustContainOneDigitAndOneUppercaseLetter": "必须至少包含一个数字和一个大写字母",
    "status403": "禁止访问服务器。请稍后重试",
    "status400": "请检查您选定的数据，稍后重试",
    "status500": "服务器异常，请稍后重试",
    "default": "抱歉，发生错误，请稍后重试",
    "campaignFulfillError": "您需要完成字段设置以策划广告活动",
    "selectAudienceGroups": "您尚未设置活动目标受众，请至少选择一个",
    "selectVisitPeriod": "您尚未设置访问地址的时间周期，请指定访问频次",
    "selectBrands": "请选择品牌。",
    "selectDemographics": "请设置目标受众的人口统计属性",
    "selectTimeline": "请设置广告上线时间",
    "pastTimeline": "您的活动已经设置过，请更改投放时间",
    "budgetTimeSpan": "请选择活动预算的投放时间",
    "budgetNoSet": "预算不能为零，请设置预算金额",
    "minimalBudget": "预算不得少于X。请分配更多预算",
    "budgetPaymentMethod": "由于支付方式错误，平台无法分配预算给您的活动。请检查您的付款方式设置",
    "budgetCurrency": "您的帐户中尚未设置货币单位",
    "selectPlatform": "请选择活动媒体平台",
    "campaignName": "请为您的活动设置名称",
    "unknownConnectionError": "出现未知连接错误",
    "statsUpload": "无法上传数据"
  },
  "budgetDetails": {
    "netMedia": "媒体净价",
    "dataFee": "数据费",
    "accountingFee": "服务费",
    "tax": "税费",
    "budgetDetails": "预算详情"
  },
  "profile": {
    "logout": "退出",
    "help": "Help",
    "settings": {
      "settings": "Settings",
      "twoStepVerification": "2-Step Verification",
      "enableTwoStepVerification": "Enable 2-Step Verification",
      "disableTwoStepVerification": "Disable 2-Step Verification",
      "on": "On",
      "off": "Off",
      "authenticatorApp": "Authenticator app",
      "authenticatorAppDescription": "Use the Authenticator app to get free verification codes",
      "setup": "Set up",
      "downloadApp": "Download Authenticator App",
      "downloadAuthenticatorApp": "Download Google Authenticator App (or anything else supporting TOTP)",
      "enterOtp": "Enter OTP",
      "firstOtp": "Enter first OTP",
      "secondOtp": "Enter second OTP",
      "confirmEnable2faMessage": "Click 'save and log out'. It will log you out and enforce next login using 2FA",
      "confirmDisable2faMessage": "Click 'save and log out'. It will log you out and disable 2FA usage",
      "confirm": "Confirm",
      "saveAndLogout": "Save and log out",
      "verify": "Verify",
      "next": "Next"
    }
  },
  "guidedTour": {
    "stepPagination": "{{currentStepNumber}} 的 {{numberOfSteps}}"
  },
  "validationErrors": {
    "required": "Required",
    "invalidCode": "Invalid code"
  },
  "clients": {
    "clients": "Clients",
    "invalidName": "Invalid name",
    "clientName": "Client name",
    "addNewClient": "Add new client",
    "details": "Details",
    "createNewClient": "Create a new client",
    "clientDetails": "Client details",
    "category": "Category",
    "companyName": "Company name",
    "companyAddress": "Company address",
    "currency": "Currency",
    "country": "Country",
    "timezone": "Timezone",
    "brandsOwnStores": "Brand / Brands for OWN Stores",
    "addAnother": "Add another",
    "addTeamMember": "Add team member",
    "clientCreated": "Great! Client has been created",
    "inviteTeammates": "Invite your teammates to collaborate",
    "backToList": "Back to list",
    "sendInvite": "Send invite",
    "goBack": "Go back",
    "createSuccessDialog": {
      "clientCreated": "Great! Client has been created",
      "inviteTeammates": "Invite your teammates to collaborate",
      "addTeammates": "Add teammates",
      "planCampaign": "Plan campaign"
    },
    "teamMembersDialog": {
      "inviteNewMembers": "Invite new members",
      "invitedMembers": "Invited members",
      "addTeamMembers": "Add team members for {{clientName}}",
      "typeEmailAddress": "Type email address",
      "sendInvite": "Send invite",
      "removeUser": "Remove user",
      "noUsers": "No one has been added to this client yet",
      "invitationSent": "Invitation has been sent.",
      "openInvitedMembers": "Open then \"Invited members\" tab to manage the list."
    },
    "roles": {
      "none": "None",
      "mediaPlanner": "Media planner",
      "accountManager": "Account manager"
    },
    "typeClientName": "Type client's name"
  },
  "clientInvitation": {
    "invalidToken": "Invalid token",
    "welcome": "欢迎",
    "toCosmose": "访问 Cosmose Media",
    "setup": "请花费稍许时间, 创建你的账户信息",
    "getStarted": "开始",
    "setupProfile": "设置个人基本信息",
    "signedUpWith": "请填写邮箱完成信息注册",
    "passwordRequirerments": {
      "passwordRequirerments": "设置密码",
      "mustContain": "密码设置中需包含",
      "digit": "至少一个数字",
      "lowerCaseLetter": "至少一个小写字母",
      "upperCaseLetter": "至少一个大写字母",
      "minLength": "密码长度不能少于12个字符"
    },
    "wrongAccount": "Wrong account?",
    "instead": "instead",
    "passwordsDoNotMatch": "Passwords do not match",
    "serverErrorMessage": "Sorry! Something went wrong. Please try again later and if the issue still exists, leave us your feedback."
  },
  "pushNotifications": {
    "Notification name": "Notification name",
    "Cities": "Cities",
    "Shopping malls": "Shopping malls",
    "Brands": "Brands",
    "Timeline": "Timeline",
    "Status": "Status",
    "Notifications": "Notifications",
    "Search by name": "Search by name",
    "Create notification": "Create notification",
    "Create new notification": "Create new notification",
    "Leave setup": "Leave setup",
    "Edit": "Edit",
    "Select locations to capture audience": "Select locations to capture audience",
    "Next": "Next",
    "Back": "Back",
    "Type city name e.g. Kuala Lumpur": "Type city name e.g. Kuala Lumpur",
    "Type shopping mall name": "Type shopping mall name",
    "Select start date": "Select start date",
    "Select end date": "Select end date",
    "Campaign timeline": "Campaign timeline",
    "Notifications setup summary": "Notifications setup summary",
    "Campaign name": "Campaign name",
    "Start": "Start",
    "End": "End",
    "Delete": "Delete",
    "Start campaign": "Start campaign",
    "Edit notification name": "Edit notification name",
    "Type brand name e.g. Kuala Lumpur": "Type brand name e.g. Kuala Lumpur",
    "Type brand name": "Type brand name",
    "DRAFT": "Draft",
    "ON_AIR": "On air",
    "SCHEDULED": "Scheduled",
    "ALL": "All",
    "FINISHED": "Finished",
    "Hurray!": "Hurray!",
    "Your notifications campaign \"{{campaignName}}\" is going to start soon": "Your notifications campaign \"{{campaignName}}\" is going to start soon",
    "Back to dashboard": "Back to dashboard",
    "Create new campaign": "Create new campaign",
    "Client": "Client",
    "Start date must be before end date": "Start date must be before end date",
    "Notification update failed": "Notification update failed",
    "Notification create failed": "Notification create failed",
    "Notification delete failed": "Notification delete failed",
    "Notification deleted": "Notification deleted",
    "+ {{value}} more": "+ {{value}} more",
    "Stop campaign": "Stop campaign",
    "No": "No",
    "Yes": "Yes",
    "Please confirm stopping the campaign": "Please confirm stopping the campaign",
    "Please confirm deleting the campaign": "Please confirm deleting the campaign",
    "Notification updated": "Notification updated",
    "Notification name update failed": "Notification name update failed",
    "Notification start failed": "",
    "Type city name e": {
      "g": {
        " Kuala Lumpur": "Type city name e.g. Kuala Lumpur"
      }
    }
  },
  "mainHeader": {
    "Content audit": "内容审核",
    "Media campaigns": "媒体活动",
    "Notifications": "通知",
    "Global search": "全局搜索",
    "Lockscreen campaigns": "锁屏活动"
  },
  "HONOR_LAYOUT": {
    "SECTIONS": {
      "AUDIT": "审核",
      "REPORTS": "报告",
      "SETTINGS": "设置"
    },
    "ITEMS": {
      "CONTENT_AUDIT": "内容审核",
      "REJECTION_REASONS": "拒绝原因",
      "WORKLOAD": "工作量",
      "CONTENT": "内容",
      "AUDIT_RATE": "审核率",
      "MANAGE_ACCESS": "访问管理"
    }
  },
  "FILTERS": {
    "FIELD": {
      "AUDITORS": "审核员",
      "HONOR_CATEGORY": "类别",
      "HONOR_LANGUAGE": "语言",
      "REJECTION_REASONS": "拒绝原因"
    },
    "NONE": "无",
    "GLOBAL": "全局",
    "OPTIONS": {
      "ALL": "全部"
    }
  },
  "2FA Code": "",
  "2FA Code is required": "",
  "Address": "",
  "All": "",
  "Almost there!": "",
  "An unexpected error occurred": "",
  "Application error occurred": "",
  "Are you sure?": "",
  "Budget amount update failed": "",
  "Budget data fee update failed": "",
  "Budget percentage split update failed": "",
  "Budget reach update failed": "",
  "Budget reset failed": "",
  "Budget view frequency update failed": "",
  "Campaign delete failed": "",
  "Campaign name update failed": "",
  "Campaign publish failed": "",
  "Campaign stages update failed": "",
  "Campaign timeline update failed": "",
  "Campaign update failed": "",
  "Change password": "",
  "Choose a client": "",
  "Client has been created!": "",
  "Client has been updated!": "",
  "Code must contains 6 characters": "",
  "Details": "",
  "Drag and drop a file to upload": "",
  "Email": "",
  "Email address": "",
  "Email address required": "",
  "Email incorrect!": "",
  "Email is required": "",
  "Email required!": "",
  "Empty list": "",
  "Error": "",
  "Error occured": "",
  "Error occurred": "",
  "Error occurred while saving campaign": "",
  "Error occurred!": "",
  "Forgot your password?": "",
  "GLOBAL_SEARCH": {
    "LIST": {
      "HEADER": "全局搜索"
    }
  },
  "Incorrect email address": "",
  "CONTENT_AUDIT": {
    "LIST": {
      "HEADER": "内容审核"
    },
    "AUTO_AUDIT": {
      "RESULTS": {
        "ACCEPT": "通过",
        "DUBIOUS": "可疑",
        "VALIDATE": "验证",
        "REJECT": "驳回",
        "UNKNOWN": "未知"
      }
    }
  },
  "LOCKSCREEN": {
    "COPIED_TO_CLIPBOARD": {
      "CLOSE": "关闭",
      "LABEL": "已复制到剪贴板！"
    },
    "DETAILS": {
      "BUTTONS": {
        "CANCEL": "取消",
        "CONFIRM": "确认",
        "REJECT": "拒绝",
        "REJECTION_REASON": "拒绝原因",
        "APPROVE": "批准",
        "WITHDRAW": "撤回",
        "RESUME": "恢复",
        "RE_AUDIT": "重新审核",
        "PUBLISH": "发布"
      },
      "DIALOGS": {
        "REJECT": {
          "DESCRIPTION": "描述",
          "INFO": "请选择活动的拒绝原因",
          "REASON": "原因",
          "REJECTION_CUSTOM_REASON": "拒绝原因",
          "REJECTION_DESCRIPTION": "拒绝描述",
          "REJECTION_REASON": "拒绝原因",
          "SELECT_REJECTION_REASON": "选择原因",
          "TITLE": "确定吗？",
          "TOOLTIP": "请提供拒绝原因"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "请稍后再试！",
        "TITLE": "无数据"
      },
      "ERROR": {
        "DESCRIPTION": "请稍后再试！",
        "SNACKBAR_TEXT": "发生意外错误。",
        "TITLE": "发生意外错误。"
      },
      "INFO": "请向下滚动查看锁屏活动的详细信息",
      "LABELS": {
        "AUDIENCE": "受众",
        "CAMPAIGN_NAME": "活动名称",
        "CATEGORY": "类别",
        "CONTENT": "内容",
        "COPYRIGHT": "版权",
        "COUNTRIES": "市场",
        "CTA": "行动号召",
        "DESCRIPTION": "描述",
        "DURATION": "时长",
        "DURATION_IN_DAYS": "时长（天）",
        "IMAGE_PROVIDER": "图片供应商",
        "LANDING_PAGE_URL": "落地页URL",
        "LANGUAGE": "语言",
        "NAME": "名称",
        "PUBLICATION": "发布",
        "PUBLISHER": "发布商",
        "START_DATE": "开始日期",
        "TAGS": "标签",
        "TARGET_LANGUAGES": "目标语言",
        "TITLE": "标题",
        "TYPE": "类型",
        "AUTO_AUDIT_TIME": "机审时间",
        "HUMAN_AUDIT_TIME": "人审时间",
        "ID": "ID",
        "IMAGE": "图片",
        "IMAGE_PREVIEW": "图片预览",
        "LINK": "链接",
        "MARKET": "市场",
        "PREVIEW": "预览",
        "PREVIEW_ALL": "预览全部",
        "REAL_PHONE": "真机",
        "REAL_PHONE_PREVIEW": "真机预览",
        "REVIEW_LOCK_SCREEN_RESOURCE": "审核锁屏资源",
        "SAFE_ZONE": "安全区",
        "SAFE_ZONE_PREVIEW": "安全区预览",
        "URL": "URL",
        "REVIEWING": "正在审核 {{current}} / {{total}}",
        "PREVIOUS": "上一个",
        "NEXT": "下一个"
      },
      "STATUS_UPDATED": {
        "TITLE": "活动状态已更新。"
      },
      "TABS": {
        "AUDIENCE": "受众",
        "CONTENT": "内容",
        "DURATION": "时长",
        "PUBLISHER": "发布商"
      }
    },
    "FILTERS": {
      "ADVERTISER": {
        "OPTIONS": {
          "ALL": "全部"
        }
      },
      "CATEGORY": {
        "OPTIONS": {
          "ALL": "全部"
        }
      },
      "LANGUAGE": {
        "OPTIONS": {
          "ALL": "全部",
          "ENGLISH": "英语",
          "INDONESIAN": "印尼语",
          "MALAY": "马来语",
          "THAI": "泰语",
          "VIETNAMESE": "越南语",
          "FRENCH": "法语",
          "SPANISH": "西班牙语"
        }
      },
      "RESOURCE_TYPE": {
        "OPTIONS": {
          "ALL": "全部",
          "CAMPAIGN": "活动",
          "CONTENT": "内容",
          "REPORTS": "报告"
        }
      }
    },
    "LIST": {
      "BUTTONS": {
        "OPEN_DETAILS": "详情"
      },
      "COLUMNS": {
        "AUDIT": {
          "PASS": "通过",
          "DUBIOUS": "可疑",
          "FAIL": "失败",
          "TITLE": {
            "LABEL": "标题机审结果"
          },
          "DESCRIPTION": {
            "LABEL": "描述机审结果"
          },
          "IMAGE": {
            "LABEL": "图片机审结果"
          },
          "H5": {
            "LABEL": "H5机审结果"
          }
        },
        "AUDITOR": {
          "LABEL": "审核员"
        },
        "AUTO_AUDIT_RESULT": {
          "LABEL": "机审结果"
        },
        "AUTO_AUDIT_TIME": {
          "LABEL": "机审时间"
        },
        "AVG_TIME_ARTICLE": {
          "LABEL": "文章平均阅读时长"
        },
        "AVG_TIME_LOCKSCREEN": {
          "LABEL": "锁屏图片平均查看时长"
        },
        "CATEGORY": {
          "LABEL": "类别"
        },
        "CLICKS": {
          "LABEL": "点击"
        },
        "COUNTRIES": {
          "LABEL": "市场"
        },
        "CTR": {
          "LABEL": "点击率"
        },
        "DURATION": {
          "LABEL": "时长（天）"
        },
        "HUMAN_AUDIT_TIME": {
          "LABEL": "人审时间"
        },
        "ID": {
          "COPY_TO_CLIPBOARD": "复制ID到剪贴板！",
          "VALUE": "ID: {{value}}",
          "LABEL": "ID"
        },
        "IMPRESSIONS": {
          "LABEL": "曝光"
        },
        "LANGUAGE": {
          "LABEL": "语言"
        },
        "OEM": {
          "LABEL": "厂商"
        },
        "REJECTED_REASON": {
          "LABEL": "拒绝原因"
        },
        "REJECTED_REASON_DESCRIPTION": {
          "LABEL": "拒绝原因描述"
        },
        "RESOURCE_TYPE": {
          "LABEL": "资源类型"
        },
        "START_DATE": {
          "LABEL": "开始日期"
        },
        "STATUS": {
          "LABEL": "状态"
        },
        "TITLE": {
          "EMPTY_LABEL": "无标题"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "请尝试更改关键词或筛选条件。",
        "TITLE": "没有符合条件的结果。"
      },
      "ERROR": {
        "DESCRIPTION": "请稍后再试！",
        "TITLE": "发生意外错误。"
      },
      "FILTERS": {
        "ADVERTISER": {
          "LABEL": "广告主"
        },
        "CATEGORY": {
          "LABEL": "类别"
        },
        "COUNTRY": {
          "LABEL": "市场"
        },
        "DATEPICKER": {
          "AUTO_AUDIT_TIME": "机审时间",
          "START_END_TIME": "开始 / 结束时间",
          "DATE_RANGE": "日期范围",
          "HUMAN_AUDIT_TIME": "人审时间",
          "PRESETS": {
            "ALL": "全部",
            "CURRENT_MONTH": "当月",
            "LAST_7_DAYS": "最近7天",
            "NEXT_MONTH": "下月",
            "PREVIOUS_MONTH": "上月",
            "TODAY": "今天"
          },
          "PUBLISH_LABEL": "发布日期范围"
        },
        "LANGUAGE": {
          "LABEL": "语言"
        },
        "SORT_BY": {
          "LABEL": "排序方式"
        },
        "SORT_ORDER": {
          "LABEL": "排序顺序"
        },
        "STATUS": {
          "LABEL": "状态"
        },
        "RESET": "重置筛选"
      },
      "HEADER": "锁屏活动",
      "METRICS": {
        "INFO": "所有指标基于活动开始以来的汇总数据。日期选择不影响显示的数据。",
        "LABEL": "指标"
      },
      "TOTAL_ELEMENTS": {
        "LABEL": "总计：{{value}}"
      }
    },
    "REPORTS": {
      "LOADING": "正在加载报告...",
      "SELECT_FILTERS": "选择筛选条件并应用以生成报告。",
      "GENERATE": "生成",
      "GENERATE_TITLE": "生成报告",
      "TYPE": {
        "CONTENT": "Content",
        "WORKLOAD": "Workload",
        "AUDIT_RATE": "Audit rate"
      },
      "LIST": {
        "HEADER": "Reports"
      },
      "WORKLOAD": {
        "HEADER": "Workload report"
      },
      "CONTENT": {
        "HEADER": "Content report"
      },
      "AUDIT_RATE": {
        "HEADER": "Audit rate report"
      }
    },
    "SHARED": {
      "DATEPICKER": {
        "END_DATE": "结束日期",
        "ENTER_DATE_RANGE": "活动日期范围",
        "START_DATE": "开始日期"
      },
      "SEARCH": {
        "LABEL": "搜索"
      },
      "SNACKBAR": {
        "CHECK_DETAILS": "查看详情"
      }
    },
    "STATUSES": {
      "ALL": "全部",
      "APPROVED": "已批准",
      "CANCELLED": "已取消",
      "EXPIRED": "已过期",
      "IN_REVIEW": "审核中",
      "LIVE": "上线",
      "REJECTED": "已拒绝"
    }
  },
  "Login": "",
  "New password": "",
  "No results for selected criteria": "",
  "Notification create failed": "",
  "Notification name update failed": "",
  "Password": "",
  "Password doesn't match": "",
  "Password is required": "",
  "Password must contain at least one numeric character": "",
  "Password required": "",
  "Passwords must be at least 8 characters in length": "",
  "Repeat password": "",
  "Reset password": "",
  "Return": "",
  "Role has been changed!": "",
  "Search category name": "",
  "Stores in": "",
  "Target": "",
  "Temporary password": "",
  "Timezone": "",
  "Total conversions": "",
  "Traffic": "",
  "Try again later!": "",
  "Try changing the keywords or filters": "",
  "URL address": "",
  "Uploading": "Uploading",
  "User has been already added!": "",
  "User has been removed!": "",
  "add": "",
  "clear all": "",
  "e": {
    "g": {
      " https://www": {
        "kaikai": {
          "ai": ""
        }
      }
    }
  },
  "label selected": "",
  "labels selected": "",
  "select all": ""
}